import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-group-icon',
  templateUrl: './communication-group.component.html'
})
export class CommunicationGroupComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
